import Login from "./components/Login"
import Forgot from "./components/ForgotPassword"
import ForceChangePassword from "./components/ForceChangePassword"
import ForgotResetPassword from "./components/ForgotResetPassword"

let module = "auth"

export default [
  { path: "forgot", component: Forgot, props: true, meta: { module: module, permissions: ["all"] } },
  { path: "forgot/resetpassword/:token", component: ForgotResetPassword, props: true, meta: { module: module, permissions: ["all"] } },

  { path: "login", component: Login, props: true, meta: { module: module, permissions: ["all"] } },
  { path: "forcechangepassword", component: ForceChangePassword, props: true, meta: { module: module, permissions: ["all"] } }
]
